/**
 * 共用数据模块接口列表api
 */

import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import qs from "../node_modules/qs/lib/index"; // 按需导入qs模块:post请求用到
const nhtj = {
  //导入
  propertyItemOfMeasureTemplateExcelImport(obj){
    return axios.post('/api/propertyItemOfMeasureTemplateExcelImport',
    obj,
    );
  },
  //  查询租户
  getQuantity (
    measureId, //测量点id
    startTime, //开始时间
    endTime, //结束时间
    pointCode, //测点编码
    pointNumber, //测量编号
    dutyTeamId //值班队伍id，0或空（不传）则不限定值班队伍
  ) {
    let params = {
      measureId: measureId,
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      pointCode: pointCode,
      pointNumber: pointNumber,
      dutyTeamId: dutyTeamId,
    };
    return axios.get(base.nhtj.getQuantity, {
      params,
    });
  },
  getQuantity2 (
    measures, //测量点id
    startTime, //开始时间
    endTime, //结束时间
    dutyTeamId //值班队伍id，0或空（不传）则不限定值班队伍
  ) {
    let params = {
      measures: measures,
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      dutyTeamId: dutyTeamId,
    };
    return axios.post(base.nhtj.getQuantity2, qs.stringify(params));
  },
  getEnergySpaceAnalysis () {
    let params = {};
    return axios.post(base.nhtj.getEnergySpaceAnalysis, qs.stringify(params));
  }, //节能空间分析报告
  getEnergyCostAnalysis () {
    let params = {};
    return axios.post(base.nhtj.getEnergyCostAnalysis, qs.stringify(params));
  }, //用能成本分析报告
  getEnergyCheckAnalysis () {
    let params = {};
    return axios.post(base.nhtj.getEnergyCheckAnalysis, qs.stringify(params));
  }, //用能体检分析报告
  downloadEnergySpaceAnalysis (fileName) {
    let params = {
      fileName: fileName,
    };
    return axios.post(
      base.nhtj.downloadEnergySpaceAnalysis,
      qs.stringify(params)
    );
  }, //节能空间报告下载
  downloadEnergyCostAnalysis (fileName) {
    let params = {
      fileName: fileName,
    };
    return axios.post(
      base.nhtj.downloadEnergyCostAnalysis,
      qs.stringify(params)
    );
  }, //用能成本报告下载
  downloadEnergyCheckAnalysis (fileName) {
    let params = {
      fileName: fileName,
    };
    return axios.post(
      base.nhtj.downloadEnergyCheckAnalysis,
      qs.stringify(params)
    );
  },
  /**
   * 
   * @param {*} companyId 公司id，NULL/0 表示本公司
   * @param {*} name 名称,不能为空字符串，仅能是字母、下划线、数字的组合
   * @param {*} displayName 显示名称，不能为空字符串
   */
  createReportGroup (companyId, name, displayName) {
    let params = {
      companyId,
      name,
      displayName
    };
    return axios.post(base.nhtj.createReportGroup, qs.stringify(params));
  },
  /**
   * 
   * @param {*} id 组id
   * @param {*} name 名称,不能为空字符串，仅能是字母、下划线、数字的组合
   * @param {*} displayName 显示名称，不能为空字符串
   */
  modifyReportGroup (id, name, displayName) {
    let params = {
      id,
      name,
      displayName
    };
    return axios.post(base.nhtj.modifyReportGroup, qs.stringify(params));
  },
  /**
   * 
   * @param {*} id 组id
   */
  deleteReportGroup (id) {
    let params = {
      id
    };
    return axios.post(base.nhtj.deleteReportGroup, qs.stringify(params));
  },
  getReportGroups (id) {
    let params = {
      companyId: id,
    };
    return axios.post(base.nhtj.getReportGroups, qs.stringify(params));
  },
  listReport (id, groups) {
    let params = {
      companyId: id,
      groups: JSON.stringify(groups),
    };
    return axios.post(base.nhtj.listReport, qs.stringify(params));
  },
  getReportAutomaticGeneratingConfigs (companyId, groups) {
    let params = {
      companyId: companyId,
      groups: JSON.stringify(groups),
    };
    return axios.post(
      base.nhtj.getReportAutomaticGeneratingConfigs,
      qs.stringify(params)
    );
  },
  /**
   * 
   * @param {*} companyId 
   * @param {*} model 
   * @param {*} baseName 
   * @param {*} params 
   * @param {*} loopRegulation 
   * @param {*} startTime 
   * @param {*} endTime 
   * @param {*} groupId 
   */
  /* 新增任务报告 */
  addReportAutomaticGeneratingConfig (companyId, model, baseName, params, loopRegulation, startTime, endTime, groupId) {
    let paramsOne = {
      companyId,
      model,
      baseName,
      params,
      loopRegulation,
      startTime,
      endTime,
      groupId
    };
    return axios.post(
      base.nhtj.addReportAutomaticGeneratingConfig,
      qs.stringify(paramsOne)
    );
  },
  /**
   * 
   * @param {*} companyId 
   * @param {*} model 
   * @param {*} id 
   * @param {*} baseName 
   * @param {*} params 
   * @param {*} loopRegulation 
   * @param {*} startTime 
   * @param {*} endTime 
   * @param {*} groupId 
   */
  /* 新增任务报告 */
  modifyReportAutomaticGeneratingConfig (companyId, model, id, baseName, params, loopRegulation, startTime, endTime, groupId) {
    let paramsOne = {
      companyId,
      model,
      id,
      baseName,
      params,
      loopRegulation,
      startTime,
      endTime,
      groupId
    };
    return axios.post(
      base.nhtj.modifyReportAutomaticGeneratingConfig,
      qs.stringify(paramsOne)
    );
  },
  /**
   * 
   * @param {*} configId 配置id
   */
  deleteReportAutomaticGeneratingConfig (id) {
    let param = {
      id
    };
    return axios.post(
      base.nhtj.deleteReportAutomaticGeneratingConfig,
      qs.stringify(param)
    )
  },
  testReportByConfig (
    model,
    baseName,
    params,
    loopRegulation,
    time,
  ) {
    let param = {
      model: model,
      baseName: baseName,
      params: params,
      loopRegulation: loopRegulation,
      time: typeof (time) == 'string' ? time.replace(/-/g, '/') : time,
    };
    return axios.post(base.nhtj.testReportByConfig, qs.stringify(param));
  },
  getConfigsByModelAndGroup (model, groupId) {
    let param = {
      model: model,
      groupId: groupId,
    };
    return axios.post(base.nhtj.getConfigsByModelAndGroup, qs.stringify(param));
  },
  getAllDemandByOrg (startTime, endTime, orgId, className, companyId) {
    let param = {
      startTime: typeof (startTime) == 'string' ? startTime.replace(/-/g, '/') : startTime,
      endTime: typeof (endTime) == 'string' ? endTime.replace(/-/g, '/') : endTime,
      orgId: orgId,
      className: className,
      companyId: companyId,
    };
    return axios.post(base.nhtj.getAllDemandByOrg, qs.stringify(param));
  },
  getDemandScheme (id) {
    let param = {
      id: id,
    };
    return axios.post(base.nhtj.getDemandScheme, qs.stringify(param));
  },
  getPointedDemandSchemeInfo (orgId, companyId, demandDate) {
    let param = {
      orgId: orgId,
      companyId: companyId,
      demandDate: demandDate,
    };
    return axios.post(
      base.nhtj.getPointedDemandSchemeInfo,
      qs.stringify(param)
    );
  },
  saveDemandScheme (isPointed, name, displayName, updateTime, orgId, details) {
    let param = {
      isPointed: isPointed,
      name: name,
      displayName: displayName,
      updateTime: updateTime,
      orgId: orgId,
      details: JSON.stringify(details),
    };
    return axios.post(base.nhtj.saveDemandScheme, qs.stringify(param));
  },
  deleteDemandScheme (id) {
    let param = {
      id: id,
    };
    return axios.post(base.nhtj.deleteDemandScheme, qs.stringify(param));
  },
  setPointedScheme (id, isPointed) {
    let param = {
      id: id,
      isPointed: isPointed,
    };
    return axios.post(base.nhtj.setPointedScheme, qs.stringify(param));
  },
  getCapacitySum (orgId, companyId, className) {
    let param = {
      orgId: orgId,
      companyId: companyId,
      className: className,
    };
    return axios.post(base.nhtj.getCapacitySum, qs.stringify(param));
  },
};

export default nhtj;
